import { rgba } from "polished";
import styled, { css } from "styled-components";
import Icon from "../../../../../../base/icons/icon/index.js";
import { FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
const variantStylesIconBadgeMobile = (variant = '', modifier = 'DEFAULT')=>({
        DISNEY: ({
            DEALS: css`
				background-color: var(--icon-badge-disney-bg);
			`,
            BLACKFRIDAY: css`
				background-color: var(--icon-badge-disney-bg);
			`,
            DEFAULT: css`
				background-color: var(--icon-badge-disney-bg);
			`
        })[modifier]
    })[variant.toUpperCase()] ?? ({
        DEALS: css`
			background-color: var(--icon-badge-is-deal-bg);
		`,
        BLACKFRIDAY: css`
			background-color: var(--icon-badge-is-black-friday-bg);
		`,
        DEFAULT: css`
			background-color: var(--icon-badge-bg);
		`
    })[modifier];
export const IconBadgeMobile = styled.div.withConfig({
    displayName: "styled__IconBadgeMobile",
    componentId: "sc-cb7b11b-0"
})`
	--icon-badge-bg: ${({ theme  })=>rgba(theme.colors.primary.lighter, 0.9)};
	--icon-badge-is-deal-bg: ${({ theme  })=>rgba(theme.colors.status.offer, 0.9)};
	--icon-badge-is-black-friday-bg: ${({ theme  })=>theme.colors.black.base};
	--icon-badge-disney-bg: ${({ theme  })=>rgba(theme.colors.status.offer, 0.9)};

	${({ $variant  })=>variantStylesIconBadgeMobile($variant)}
	color: ${({ theme  })=>theme.colors.white.base};
	position: absolute;
	top: 4px;
	left: 0;
	padding: 8px;
	${FontMixin({
    size: 'larger'
})}
	z-index: ${({ theme  })=>theme.zIndex.lowest};

	${Icon} {
		${FontMixin({
    size: 'large',
    height: 'large',
    weight: 'regular'
})}
	}

	&.is-deal {
		${({ $variant  })=>variantStylesIconBadgeMobile($variant, 'DEALS')}
	}

	&.is-blackfriday {
		${({ $variant  })=>variantStylesIconBadgeMobile($variant, 'BLACKFRIDAY')}
	}

	& .discount {
		${FontMixin({
    size: 'larger',
    height: 'base',
    weight: 'regular'
})}

		&::before {
			content: '- ';
		}

		&::after {
			content: '%';
		}
	}
`;

//# sourceMappingURL=styled.js.map